import { environment as ENV } from '@environment';

export function isDevelopmentEnvironmentByAmplitude(): boolean {
  return !ENV.production && ENV.urlPath.indexOf(location.origin) !== -1;
}
